module.exports = __webpack_public_path__ + "static/media/63.8b8fd971.jpeg";